<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center">
          <grid-col col-size="4">
            <h1 class="header margin-top-xl">
              <chevron
                @click="$router.push({name: 'QueryList'})"/>
              {{$t('query.editQuery')}}
            </h1>
            <alert
              v-if="alertVisible"
              :message="alertMessage"
              :type="alertType">
            </alert>
          </grid-col>
        </grid-row>
        <form v-on:submit.prevent v-on:keypress.enter.prevent="onSave">
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="variable-input-field variable-input-field-name">
              <label-input
                form-size="m"
                :label="$t('query.name')"
                :type="'text'"
                v-model="editQuery.name"
                :error="nameError"
                :errorMessage="$t('commons.mandatoryFieldMessage')">
              </label-input>
            </div>
          </grid-col>
        </grid-row>
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="variable-input-field align-right">
              <checkbox
                :disabled="editQuery.mine == false"
                id="query-enabled"
                :label="$t('query.star')"
                v-on:change="onStarhanged"
                :checked="editQuery.star">
              </checkbox>
            </div>
            <div class="variable-input-field submit-buttons align-right">
              <br>
              <btn-pill
                :btnText="$t('commons.cancel')"
                v-on:click="onCancel"
                btn-size="m"
                btn-type="secondary">
              </btn-pill>
              <btn-pill
                :btnText="$t('commons.save')"
                v-on:click="onSave"
                btn-size="m">
              </btn-pill>
            </div>
          </grid-col>
        </grid-row>
        </form>
      </div>
    </main-layout>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import LabelInput from '@/components/shared/forms/LabelInput';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import Radio from '@/components/shared/forms/Radio';
import ToggleSwitch from '@/components/shared/forms/ToggleSwitch';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Checkbox from '@/components/shared/forms/Checkbox';
import Alert from '@/components/shared/alert/Alert';
import Chevron from '@/components/shared/Chevron';

export default {
  components: {
    MainLayout,
    GridRow,
    GridCol,
    LabelInput,
    LabelSelect,
    Radio,
    ToggleSwitch,
    BtnPill,
    Checkbox,
    Alert,
    Chevron
  },
  created () {
    this.editQuery = this.$route.params;
  },
  data () {
    return {
      editQuery: {},
      /* Form field errors */
      nameError: false,
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '' // error, warning, success
    };
  },
  methods: {
    onSave () {
      this.nameError = false;
      if (isValidForm(this)) {
        updateQuery(this, this.editQuery);
      } else {
        this.nameError = true;
      }
    },
    onCancel () {
      this.$router.push({name: 'QueryList'});
    },
    onStarhanged (selected) {
      this.editQuery.star = selected;
    },
    ...mapActions([
      'updateQuery'
    ])
  },
  computed: {
    getBreadcrumb () {
      const personalArea = this.$t('menu.workspace');
      const queryList = this.$t('query.title');
      const query = this.$t('query.editQuery');
      return [
        {name: personalArea, link: '/workspace'},
        {name: queryList, link: '/query/list'},
        {name: query, link: '/query', disabled: true}];
    }
  }
};

const isValidForm = context => {
  return context.editQuery.name.length > 0;
};

const updateQuery = (context, query) => {
  const msg = context.$t('query.successUpdate', {name: query.name});
  context.updateQuery({context: context, query}).then(() => {
    context.$router.replace({ name: 'QueryList', params: {alert: msg} });
  }).catch(() => {
    showAlert(context, context.$t('query.errorUpdate'), 'error');
  });
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};

</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  .align-right {
    float: right;
    clear:both;
  }

  .variable-input-field {
    display: inline-block;
  }

  .variable-input-field-name {
    width: 100%;
    margin: 0 0;
  }

  .variable-input-field-unit {
    min-width: 0px;
    width: 25%;
    float: right;
    margin: 0 0;
  }

  .first-operand {
    float: left;
    width: 35%;
    margin: 0 0;
  }

  .operator {
    width: 10%;
    margin: 0 0;
  }

  .second-operand {
    width: 54.5%;
    margin: 0 0;
    float: right;
  }

  .variable-input-variable-or-constant-field {
    width: 70%;
  }

  .variable-input-variable-or-constant-toggle {
    margin-top: 2rem;
    float: right;
    display: inline-block;
  }

  .submit-buttons {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/queries/Query.vue